import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PhoneNumberInput from "src/Components/Authentication/PhoneNumberInput";
import Loader from "src/Components/Common/Loader";
import UserService from "src/Services/API/user.service";
import { handleError } from "src/Common/function";

function RequirePhoneModal() {
  const [shown, setShown] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneInvalid, setPhoneInvalid] = useState(false);
  const [showError, setShowError] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const checkPhone = async () => {
      const currentUser = UserService.getCurrentUser();
      if (!currentUser || !currentUser.id) return;
      try {
        const response = await UserService.getUser(currentUser.id);
        const user = response.data;
        if (!user?.phone || !String(user.phone).trim()) {
          setShown(true);
        }
      } catch (error) {
        if (!currentUser.phone || !String(currentUser.phone).trim()) {
          setShown(true);
        }
      }
    };
    checkPhone();
  }, []);

  const saveClicked = async () => {
    if (!phone || phoneInvalid) {
      setShowError(true);
      return;
    }
    setSaving(true);
    try {
      const currentUser = UserService.getCurrentUser();
      const response = await UserService.updateUserPartial(currentUser.id, { phone });
      if (response.status === 200 || response.status === 201) {
        UserService.saveCurrentUser({ ...currentUser, phone: response.data?.phone ?? phone });
        toast("Phone number saved");
        setShown(false);
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setSaving(false);
    }
  };

  if (!shown) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen flex items-center justify-center z-50 bg-black/50">
      <div className="w-[440px] px-5 py-5 bg-white p-[18px] flex flex-col rounded-[6px] shadow-2xs relative">
        <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-2 text-center">
          PHONE NUMBER REQUIRED
        </p>
        <p className="text-[12px] font-OpenSansRegular font-[400] text-subTitleColor mb-4 text-center">
          Please enter your phone number to continue.
        </p>

        <div className="w-full mb-4">
          <PhoneNumberInput
            label="Phone"
            value={phone}
            onChange={setPhone}
            onInvalidChange={setPhoneInvalid}
            required
            showError={showError}
          />
        </div>

        <div className="flex items-center justify-center mt-2">
          <div
            onClick={saving ? undefined : saveClicked}
            className={`w-full h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white ${
              saving ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            {saving ? <Loader variant="button" ariaLabel="saving-phone" /> : "SAVE"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequirePhoneModal;
